import * as request from 'request-promise';
import { AUTH_CONFIG } from 'services/ThomasAuth/ThomasAuthVariables';
import { RANK_CONFIG } from 'services/RankalyzerVariables';
import { Auth } from 'aws-amplify';
import cookie from 'react-cookies';

export default class ThomasAuthService {
  constructor() {
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }
  isAuthenticated = () => {
    // return true;
    Auth.currentSession()
      .then((session: any) => {
        const token = session.idToken.jwtToken;
        // console.log(`isAuth token`, token);
        // cookie.save('id_token', token, AUTH_CONFIG.THOMASNET_COOKIE_OPTIONS);
        localStorage.setItem('id_token', token);
        return true;
      })
      .catch(err => {
        console.log('error:', err);
        return false;
      });
    return false;
  };

  catchErrorResponse = (err: any) => {
    var errorModel = {
      status: 500,
      message: 'Server Error',
      body: null,
      text: ''
    };

    if (err && err.status) {
      errorModel.status = err.status;
      errorModel.message = err.message;
    }

    if (err && err.response) {
      var res = err.response;
      if (res.body) {
        errorModel.body = res.body;
      }
      if (res.text) {
        errorModel.text = res.text;
      }
    }

    return errorModel;
  };

  getAuthCookies = () => {
    let model = {
      tinid: cookie.load('tinid'),
      coreX: cookie.load('core_x'),
      coreU: cookie.load('core_u'),
      userInfo: cookie.load('user_info')
    };

    return model;
  };

  rankAuthPath = () => {
    return `${RANK_CONFIG.RANK_BASE_URL}`;
  };

  logout = (newpath: string) => {
    Auth.signOut();

    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expiresIn');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('expirationTime');
    localStorage.removeItem('issuedAtTime');
    localStorage.removeItem('clock_drift');

    cookie.remove('tinid', AUTH_CONFIG.THOMASNET_COOKIE_OPTIONS);
    cookie.remove('core_x', AUTH_CONFIG.THOMASNET_COOKIE_OPTIONS);
    cookie.remove('core_u', AUTH_CONFIG.THOMASNET_COOKIE_OPTIONS);
    cookie.remove('user_info', AUTH_CONFIG.THOMASNET_COOKIE_OPTIONS);
    cookie.remove('id_token', AUTH_CONFIG.THOMASNET_COOKIE_OPTIONS);
    cookie.remove('refresh_token', AUTH_CONFIG.THOMASNET_COOKIE_OPTIONS);
    cookie.remove('strn', AUTH_CONFIG.THOMASNET_COOKIE_OPTIONS);
    cookie.remove('roles', AUTH_CONFIG.THOMASNET_COOKIE_OPTIONS);

    //Making sure the cookies are really killed.
    cookie.remove('core_x');
    cookie.remove('core_u');
    cookie.remove('user_info');
    cookie.remove('id_token');
    cookie.remove('refresh_token');
    cookie.remove('strn');
    cookie.remove('roles');
  };
}
